export default __webpack_public_path__ + "static/media/zari_3.64121330.jpeg";